import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-18e33975"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader_wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"typing-indicator\" data-v-18e33975><div class=\"typing-circle\" data-v-18e33975></div><div class=\"typing-circle\" data-v-18e33975></div><div class=\"typing-circle\" data-v-18e33975></div><div class=\"typing-shadow\" data-v-18e33975></div><div class=\"typing-shadow\" data-v-18e33975></div><div class=\"typing-shadow\" data-v-18e33975></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.itsTime)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}